import { useContext } from "react";

import type { IMeetingUploadContext } from "@/contexts/MeetingUploadContext";
import { MeetingUploadContext } from "@/contexts/MeetingUploadContext";

// NOTE: Reads the app-level upload store. Any page or component can start,
// observe, or cancel a meeting upload without owning its lifecycle — that is
// what lets the Uploads page unmount mid-upload while the transfer keeps
// running (NSAI-5141).
export const useMeetingUploads = (): IMeetingUploadContext => {
  const context = useContext(MeetingUploadContext);

  // NOTE: this guard ensures the hook is used within its required provider and does not need test coverage.
  /* istanbul ignore next */
  if (context === null) {
    throw new Error(
      "useMeetingUploads must be used within a MeetingUploadProvider",
    );
  }

  return context;
};
